import {
  useGetAdminConnectivityRecordKeepers,
  usePostAdminConnectivityRecordKeepers
} from '@ijoin/hooks';
import { createFileRoute } from '@tanstack/react-router';

import { ConnectivityChecks } from '../../components';

const RecordKeepersConnectivityPage = () => (
  <ConnectivityChecks
    label='record keeper'
    queryKey='/api/v3/admin/connectivity/record-keepers'
    sortField='advisoryOrganizations'
    testId='recordKeepersConnectivity'
    useQuery={useGetAdminConnectivityRecordKeepers}
    useRefresh={usePostAdminConnectivityRecordKeepers}
  />
);

export const Route = createFileRoute('/connectivity/')({
  component: RecordKeepersConnectivityPage
});
